{
  "data_driven": {
    "formula_applied": "Formel angewendet",
    "by_attributes": "Nach Attributen",
    "any_others": "Irgendwelche anderen"
  },
  "styles2": {
    "bold": "Mutig",
    "regular": "Regulär",
    "on": "Auf",
    "off": "Aus",
    "arrow_spacing": "Abstand zwischen den Pfeilen",
    "arrow_colour": "Farbe der Pfeile",
    "arrow_size": "Größe des Pfeils",
    "arrow_opacity": "Opazität des Pfeils",
    "rotation": "Drehung",
    "rotate_icon": "Symbol drehen",
    "orientation_3d": "3D-Ausrichtung",
    "flat": "Flach",
    "raised": "Angehoben",
    "degrees": "Abschlüsse",
    "model": "Modell",
    "type": "Typ",
    "scale": "Maßstab",
    "choose_model": "Wählen Sie ein Modell",
    "error_loading_models": "Beim Laden der 3D-Modelle ist ein Fehler aufgetreten",
    "solid": "Solide",
    "dashed": "Gestrichelt",
    "type_of_line": "Art der Linie",
    "Line": "Linie",
    "Area": "Bereich",
    "Point": "Punkt",
    "Icon": "Symbol",
    "Model": "Modell",
    "LineModel": "Reihe von 3D-Modellen",
    "AreaModel": "Bereich der 3D-Modelle",
    "spacing": "Abstand",
    "plural": {
      "Icon": "Ikonen",
      "Point": "Punkte"
    }
  },
  "object": {
    "deleteTitle": "Ausgewählte (s) Objekt (e) löschen",
    "deleteDescription": "Möchten Sie die ausgewählten Objekte wirklich löschen?",
    "deleteToast": "{{ count }} Objekte wurden gelöscht",
    "multiple": "Mehrere",
    "multiple_objects": "Mehrere Objekte"
  },
  "controls": {
    "draw": "Zeichnen",
    "copy": "Kopieren",
    "select": "Wählen Sie (Aktive Ebenen)",
    "area_select": "Wählen Sie (Alle Ebenen)",
    "area_select_invalid": "Der gezeichnete Bereich muss 3 oder mehr Punkte haben, um gültig zu sein",
    "analysis": "Analyse",
    "search": "Suche",
    "grab": "Schnappen",
    "toggle_3d_terrain": "3D-Gelände",
    "toggle_globe": "Ansicht des Globus",
    "toggle_3d_buildings": "Gebäude in 3D",
    "zoom_in": "Vergrößern",
    "zoom_out": "Verkleinern",
    "reset": "Ansicht zurücksetzen",
    "vr": "Digitaler Zwilling",
    "comments": "Kommentare",
    "calendar": "Kalender",
    "zoom_to_all_objects": "Auf alle Objekte zoomen",
    "no_objects_to_zoom": "Keine sichtbaren Objekte auf dem Plan",
    "bookmarks": "Lesezeichen"
  },
  "analysis": {
    "analysis_title": "Analyse-Tools",
    "distance_title": "Entfernung",
    "distance_description": "Messen Sie die Entfernung entlang einer Linie",
    "distance_content": {
      "title": "Gesamtentfernung der Referenzlinie auf der Karte"
    },
    "walk_time_title": "Zeit zu Fuß",
    "walk_time_description": "Berechne die Gehzeit entlang einer Linie",
    "walk_time_content": {
      "title": "Gesamtfahrzeit beim Gehen",
      "approx_time": "Ca. {{ speed }} Minuten bei",
      "m_per_second": "m/Sekunde"
    },
    "flow_rate_title": "Durchflussrate",
    "flow_rate_description": "Berechneter Personenfluss durch ein Tor (auf der Karte eingezeichnete Linie)",
    "flow_rate_content": {
      "total_width": "Gesamtbreite des Tores (Länge der Linie)",
      "per_minute_per_hour": "{{ perMinute }} pro {{ perHour }} pro Stunde",
      "at": "beim",
      "people_meter_minute": "Menschen/Meter/Minute",
      "fruin_service_levels": "Serviceniveaus von Fruin"
    },
    "area_title": "Bereich",
    "area_description": "Messen Sie die Fläche innerhalb einer Form auf der Karte",
    "area_content": {
      "title": "Gesamtfläche des Referenzpolygons auf der Karte"
    },
    "capacity_content": {
      "total_area": "Gesamtfläche",
      "per_m_sq": "{{ perMSq }} pro m²",
      "at": "beim",
      "people_meter_sq": "m²//1 Person",
      "people_ft_sq": "ft²/Person",
      "fruin_service_levels": "Fruin Serviceniveaus"
    },
    "capacity_title": "Kapazität",
    "capacity_description": "Berechne die Fassungsvermögen (Personen) eines Gebietes auf der Karte",
    "count_title": "Zählen",
    "count_description": "Zählen Sie die Objekte innerhalb eines Bereichs auf der Karte",
    "count_content": {
      "total": "Insgesamt",
      "current_level": "Aktuelles Level",
      "all_levels": "Alle Stufen"
    }
  },
  "styles": {
    "line_fill": "Linie füllen",
    "colour": "Farbe",
    "colours": "Farben",
    "opacity": "Opazität",
    "blur": "Unschärfe",
    "measurement": "Messung",
    "width": "Breite",
    "offset": "Offset",
    "join_and_end": "Enden und Verbindungen",
    "join": "Tritt bei",
    "end": "Endet",
    "arrows": "Pfeile",
    "line_terminator_icon": "Symbol (e) am Ende der Linie",
    "line_terminator_icon_start": "Starten",
    "line_terminator_icon_end": "Ende",
    "line_terminator_icon_both": "Beides",
    "text": "Text",
    "text_colour": "Farbe des Textes",
    "text_font": "Schriftart des Textes",
    "text_weight": "Textstärke",
    "text_size": "Größe des Textes",
    "text_overlap": "Textüberlappung",
    "allow_text_overlap": "Alles anzeigen",
    "no_text_overlap": "Kombinieren",
    "text_outline_width": "Breite des Textumrisses",
    "text_outline_colour": "Farbe der Umrisse des Textes",
    "text_opacity": "Opazität des Textes",
    "text_content": "Inhalt des Textes",
    "outline": "Gliederung",
    "outline_type": "Gliederungstyp",
    "outline_colour": "Farbe der Kontur",
    "outline_opacity": "Opazität der Kontur",
    "outline_width": "Breite des Umrisses",
    "outline_blur": "Konturunschärfe",
    "no_colour": "Keine Farbe",
    "company_palette": "Firmen-Palette",
    "type_of_area": "Art des Bereichs",
    "area_2d": "2D-Bereich",
    "area_3d": "3D-Bereich",
    "height": "Höhe",
    "type_of_point": "Art des Punktes",
    "point_fill": "Füllen Sie Punkte",
    "radius": "Radius",
    "pitch_alignment": "3D-Ausrichtung",
    "area_fill": "Fläche füllen",
    "placement": "Platzierung",
    "pitch_alignment_map": "Flach",
    "pitch_alignment_viewport": "Angehoben",
    "pitch_alignment_map_desc": "{{ styleType }} liegen flach auf der Kartenebene",
    "pitch_alignment_viewport_desc": "{{ styleType }} wird immer zur Kamera zeigen",
    "icon": "Symbol",
    "icon_image": "Bild des Symbols",
    "icon_size": "Größe",
    "icon_colour": "Farbe",
    "icon_opacity": "Opazität",
    "rotation": "Drehung",
    "allow_overlap": "Überlappung der Symbole",
    "show_all": "Alles anzeigen",
    "combine": "Kombinieren",
    "choose_icon_image": "Wählen Sie das Symbolbild",
    "open_icon_selector": "Öffnen Sie die Symbolauswahl",
    "spacing": "Abstand",
    "model_offset": "Modellversatz",
    "line_model_line_colour": "Farbe der Linie",
    "line_model_line_width": "Breite der Linie",
    "type": "Typ der Linie",
    "line_model_line_type": "Linientyp"
  }
}